// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GAEvents from "../../../../library/ga/GAEvents.bs.js";
import * as RnrAssetManager from "../../assets/RnrAssetManager.bs.js";
import * as VersionComparator from "../../utils/version/VersionComparator.bs.js";

var copyIcon = RnrAssetManager.getImage("copy_icon.svg");

function CopyToClipboard(Props) {
  var copyable_text = Props.copyable_text;
  var container_classOpt = Props.container_class;
  var ack_modalOpt = Props.ack_modal;
  var modal_textOpt = Props.modal_text;
  var version = Props.version;
  var container_class = container_classOpt !== undefined ? container_classOpt : "copy-clipboard-container";
  var ack_modal = ack_modalOpt !== undefined ? ack_modalOpt : true;
  var modal_text = modal_textOpt !== undefined ? modal_textOpt : "Code copied";
  var match = React.useState(function () {
        return false;
      });
  var setModal = match[1];
  var getClipboardModal = function (param) {
    return React.createElement("div", {
                className: "clipboard-modal"
              }, React.createElement("div", {
                    className: "title"
                  }, modal_text));
  };
  return React.createElement("div", {
              className: container_class
            }, React.createElement("div", {
                  className: "text"
                }, copyable_text), version >= VersionComparator.getClipboardMinVersion(undefined) ? React.createElement("div", {
                    className: "button-copy",
                    onClick: (function (_event) {
                        GAEvents.publishEvent("rnr_award", "click_copy_code", undefined, copyable_text, undefined, undefined);
                        PartnerAppInterface.copyToClipboard(copyable_text);
                        Curry._1(setModal, (function (param) {
                                return true;
                              }));
                        setTimeout((function (param) {
                                return Curry._1(setModal, (function (param) {
                                              return false;
                                            }));
                              }), 3000);
                        
                      })
                  }, React.createElement("img", {
                        className: "copy-icon",
                        src: copyIcon
                      })) : null, ack_modal && match[0] ? getClipboardModal(undefined) : null);
}

var make = CopyToClipboard;

export {
  copyIcon ,
  make ,
  
}
/* copyIcon Not a pure module */
